import BaseService from '@/ecm/common/BaseService.js';
class ActivityRegistryService {
  baseUrl = 'activity-registry';

  getList = (dateTimeFrom, dateTimeTo, orderBy, activityCategories = null, messageContent = null, page = 1, pageSize = 10) => {
    const params = new URLSearchParams(
        Object.entries({ dateTimeFrom, dateTimeTo, orderBy, messageContent, page, pageSize })
            .filter(([, value]) => value != null)
    );

    if (Array.isArray(activityCategories)) {
      activityCategories.forEach(value => {
        if (value != null) {
          params.append('activityCategories', value);
        }
      });
    }

    return BaseService.get({ url: `${this.baseUrl}?${params.toString()}` });
  };

}

export default new ActivityRegistryService();